export default __webpack_public_path__ + "static/media/img-0381-switzerland-full-face.7b84cd65.png";